/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

type QtmBlack = 'rgba(0,0,0,0.87)';
export const qtmBlack: QtmBlack = 'rgba(0,0,0,0.87)';

type QtmWhite = '#FFFFFF';
export const qtmWhite: QtmWhite = '#FFFFFF';

/** Palette type */
export type QtmPalette = {
  // Primary colors
  blue: string;
  darkBlue: string;
  lightBlue: string;
  lightestBlue?: string;

  // Grays
  darkestGray?: string;
  darkGray: string;
  gray: string;
  lightGray: string;
  lightestGray?: string;

  // Grey aliases
  darkestGrey?: string;
  darkGrey?: string;
  grey?: string;
  lightGrey?: string;
  lightestGrey?: string;

  // Supporting colors
  blueGray?: string;
  darkRed: string;
  red: string;
  lightRed: string;
  lightestRed?: string;
  darkGreen: string;
  green: string;
  lightGreen: string;
  yellow: string;
  lightYellow: string;
  orange: string;
  purple: string;
  darkAqua?: string;
  aqua?: string;
  lightAqua?: string;

  contrast: {
    // Primary colors
    blue: QtmWhite | QtmBlack;
    darkBlue: QtmWhite | QtmBlack;
    lightBlue: QtmWhite | QtmBlack;
    lightestBlue?: QtmWhite | QtmBlack;

    // Grays
    darkestGray?: QtmWhite | QtmBlack;
    darkGray: QtmWhite | QtmBlack;
    gray: QtmWhite | QtmBlack;
    lightGray: QtmWhite | QtmBlack;
    lightestGray?: QtmWhite | QtmBlack;

    // Grey aliases
    darkestGrey?: QtmWhite | QtmBlack;
    darkGrey?: QtmWhite | QtmBlack;
    grey?: QtmWhite | QtmBlack;
    lightGrey?: QtmWhite | QtmBlack;
    lightestGrey?: QtmWhite | QtmBlack;

    // Supporting colors
    blueGray?: QtmWhite | QtmBlack;
    darkRed: QtmWhite | QtmBlack;
    red: QtmWhite | QtmBlack;
    lightRed: QtmWhite | QtmBlack;
    lightestRed?: QtmWhite | QtmBlack;
    darkGreen: QtmWhite | QtmBlack;
    green: QtmWhite | QtmBlack;
    lightGreen: QtmWhite | QtmBlack;
    yellow: QtmWhite | QtmBlack;
    lightYellow: QtmWhite | QtmBlack;
    orange: QtmWhite | QtmBlack;
    purple: QtmWhite | QtmBlack;
    darkAqua?: QtmWhite | QtmBlack;
    aqua?: QtmWhite | QtmBlack;
    lightAqua?: QtmWhite | QtmBlack;
  };
};

export const setGreyAliases = (palette: QtmPalette) => {
  palette.darkestGrey = palette.darkestGray;
  palette.contrast.darkestGrey = palette.contrast.darkestGray;

  palette.darkGrey = palette.darkGray;
  palette.contrast.darkGrey = palette.contrast.darkGray;

  palette.grey = palette.gray;
  palette.contrast.grey = palette.contrast.gray;

  palette.lightGrey = palette.lightGray;
  palette.contrast.lightGrey = palette.contrast.lightGray;

  palette.lightestGrey = palette.lightestGray;
  palette.contrast.lightestGrey = palette.contrast.lightestGray;
};
